export default __webpack_public_path__ + "static/media/retirement.055cbab7.png";